import React from "react";

// Components
import { IonCol } from "@ionic/react";
import MembersTableFiltersButton from "./MembersTableFiltersButton";

const MembersTableFiltersGroup = (props: any) => {
  const { group, handleClick, activeFilters } = props;

  return (
    <IonCol sizeXs={group.colSizeSm} sizeLg={group.colSizeLg}>
      <p className={"members-table-filters__label"}>{group.title}</p>
      <div className={"members-table-filters__buttons-wrap"}>
        {group.filters.map((filter: any, key: number) => {
          return <MembersTableFiltersButton key={key} text={filter.text} field={filter.key} value={filter.value} handleClick={handleClick} activeFilters={activeFilters} />;
        })}
      </div>
    </IonCol>
  );
};

export default MembersTableFiltersGroup;
